import "bootstrap/dist/css/bootstrap.min.css";
import '../custom/style/theme/style.scss';
import '../custom/style/icons/style.css';

export default true;